"use strict";

var __importDefault = function (e) {
    return e && e.__esModule ? e : {
      default: e
    };
  },
  react_1 = (Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.PlayPauseButton = void 0, __importDefault(require("react"))),
  types_1 = require("../types"),
  utils_1 = require("../utils"),
  PlayPauseButton = function (e) {
    var t = e.isPlaying,
      a = e.onClick,
      e = e.renderPlayPauseButton;
    return "function" == typeof e ? react_1.default.createElement("div", {
      className: types_1.Classnames.PLAY_BTN,
      onClick: a
    }, e({
      isPlaying: t
    })) : (e = t ? types_1.Modifiers.PAUSE : "", t = (0, utils_1.concatClassnames)(types_1.Classnames.PLAY_BTN_ITEM, e), react_1.default.createElement("div", {
      className: types_1.Classnames.PLAY_BTN
    }, react_1.default.createElement("div", {
      className: types_1.Classnames.PLAY_BTN_WRAPPER
    }, react_1.default.createElement("div", {
      onClick: a,
      className: t
    }))));
  };
exports.PlayPauseButton = PlayPauseButton;